import moment from 'moment'

const ifEmptyNull = (array) => (array != null && array.length > 0 ? array : null)

function createUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0
    var v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function createEmailParam(emailData, previousDraft) {
  const {
    draftsBox,
    sentBox,
    accountId,
    // maskedEmail,
    from,
    to,
    cc,
    bcc,
    subject,
    bodyIsHTML,
    htmlBody,
    htmlBodyText,
    textBody,
    attachments,
    // mailboxes,
    threadId: prevThreadId,
    // thread: prevThread,
    // inReplyTo,
    // references,
    // forwardedMessageId,
    replyTo,
    identityId,
    isReadReceiptRequested,
    isHighPriority,
  } = emailData

  let inReplyTo = emailData.inReplyTo
  let references = emailData.references

  let _approxSize = 0
  const inlineParts = []
  const attachedParts = []
  const now = moment() // dataObj._scheduleSend || new Date();

  attachments.forEach((attachment) => {
    const { isInline } = attachment.file
    let part
    if (attachment.isUploaded && (!isInline || attachment.isUsed)) {
      const { blobId, size, name, type, cid, imageSize } = attachment.file
      part = {
        blobId,
        size,
        type: type != null && type.length > 0 ? type : 'application/octet-stream',
        disposition: isInline ? 'inline' : 'attachment',
        cid,
        imageSize,
      }
      if (name != null) {
        // name이 없는 경우도 존재함.
        // 첨부파일명 이 윈도우 Client 들에서 자소분리상태로 보이는 현상을 막기 위해 NFC로 변환.
        part.name = name.normalize('NFC')
      }
      if (isInline) {
        inlineParts.push(part)
      } else {
        attachedParts.push(part)
      }
      _approxSize += part.size
    }
  })

  const bodyValues: any = {
    text: {
      value: bodyIsHTML ? htmlBodyText : textBody,
      isTruncated: false,
    },
  }
  if (bodyIsHTML) {
    bodyValues.html = {
      value: htmlBody,
      isTruncated: false,
    }
  }

  let bodyStructure: any = {
    partId: 'text',
    type: 'text/plain',
  }
  if (bodyIsHTML) {
    bodyStructure = {
      type: 'multipart/alternative',
      // Alternative parts go in order of least fidelity to highest
      // fidelity (Mac Mail for example will pick the last one it
      // understands), so text first, then html.
      subParts: [
        bodyStructure,
        inlineParts.length
          ? {
              type: 'multipart/related',
              subParts: [
                {
                  partId: 'html',
                  type: 'text/html',
                },
              ].concat(inlineParts),
            }
          : {
              partId: 'html',
              type: 'text/html',
            },
      ],
    }
  }
  if (attachedParts.length) {
    bodyStructure = {
      type: 'multipart/mixed',
      subParts: [bodyStructure].concat(attachedParts),
    }
  }

  let _threadId = null
  if (previousDraft) {
    _threadId = previousDraft.threadId // ???
    // If the the subject has changed,
    // the new draft get a different thread id.
    if (inReplyTo == null && previousDraft.inReplyTo != null) {
      inReplyTo = previousDraft.inReplyTo
    }
    if (references == null && previousDraft.references != null) {
      references = previousDraft.references
    }
  } else {
    _threadId = prevThreadId
  }

  // if (threadId && thread.accountId !== accountId) {
  //   threadId = null
  // }

  const mailboxIds = {}

  // mailboxes.forEach((item) => {
  //   let id = (item.data != null) ? item.data.id : item.id;
  //   mailboxIds[id] = true;
  // })

  // 메일을 만들면 일단 무조건 draft에 저장.
  const drafts = draftsBox != null && draftsBox.data != null ? draftsBox.data : draftsBox

  mailboxIds[drafts.id] = true

  // 이전 메일들(forwarding, reply 등..?)의 ID, 또는 서버에 저장된 draft의 messageId
  const domain = location.host
  const messageId = previousDraft ? previousDraft.messageId : [createUuid() + '@' + domain]

  const createProp: any = {
    mailboxIds,
    keywords: {
      $seen: true,
      $draft: true,
      ...(previousDraft ? previousDraft.keywords : null),
    },
    from,
    to: ifEmptyNull(to),
    subject,
    receivedAt: now.toISOString().split('.')[0] + 'Z',
    // size: approxSize,
    // preview: bodyValues.text.value.slice(0, 255).trim().replace(/\s+/g, ' '),
    messageId,
    cc: ifEmptyNull(cc),
    bcc: ifEmptyNull(bcc),
    sentAt: now.format(),
    bodyStructure,
    bodyValues,
  }

  // // invalidProperties 이므로 사용 하지 않음.
  // if (attachedParts.length > 0) {
  //   createProp.hasAttachment = true
  // }
  // if (threadId != null) {
  //   createProp.thread = thread
  // }
  if (inReplyTo != null) {
    createProp.inReplyTo = inReplyTo
  }
  if (references != null) {
    createProp.references = references
  }
  // if (forwardedMessageId != null) {
  //   createProp.forwardedMessageId = forwardedMessageId
  // }
  if (replyTo != null) {
    createProp.replyTo = replyTo
  }

  if (emailData['header:X-Secure-ExpirationKey:asText'] != null) {
    createProp['header:X-Secure-ExpirationKey:asText'] =
      emailData['header:X-Secure-ExpirationKey:asText']
  }

  // X-ReadReceipt-Enabled (custom header)
  // 본 헤더는 JMAP draft에 UI 토글 상태(수신확인 ON/OFF)를 보존하기 위한 용도다.
  // 실제 수신확인 메일 발송은 별도 마이크로서비스(POST /api/send)가 처리하며,
  // RFC 3798 dispositionNotificationTo 등 표준 헤더는 그 마이크로서비스가 자체 생성한다.
  // 따라서 클라이언트 측은 RFC 3798 경로(아래 dispositionNotificationTo)를 건드리지 않고,
  // custom header만 임시저장→재오픈 사이클에 보존한다 (보안 메일의 X-Secure-ExpirationKey와 동일 패턴).
  if (emailData['header:X-ReadReceipt-Enabled:asText'] != null) {
    createProp['header:X-ReadReceipt-Enabled:asText'] =
      emailData['header:X-ReadReceipt-Enabled:asText']
  }

  // if (identityId != null) {
  //   createProp.identityId = identityId;
  // }

  if (isReadReceiptRequested === true) {
    createProp.dispositionNotificationTo = from[0].email
  }

  //maskedEmail ??

  if (isHighPriority === true) {
    createProp.priority = '1 (High)'
    createProp.importance = 'high'
  }

  // const rcptToArr = [...to, ...cc, ...bcc]

  // const envelope = {
  //   mailFrom: {
  //     email: from[0].email,
  //     parameters: null,
  //   },
  //   rcptTo: rcptToArr.map((item) => {
  //     return {
  //       email: item.email,
  //       parameters: null,
  //     }
  //   }),
  // }

  const emailSubmissionProps: any = {
    // envelope,
  }

  // if (threadId != null) {
  //   emailSubmissionProps.threadId = threadId
  // }

  if (identityId != null) {
    emailSubmissionProps.identityId = identityId
  }

  const sent = sentBox.data != null ? sentBox.data : sentBox

  const sentBoxId = sent.id

  return {
    accountId,
    createProp,
    emailSubmissionProps,
    sentBoxId,
    drafts,
  }
}

const ext = {
  createUuid,
  createEmailParam,
}

export default ext
